import NewVehiclePill from './new-vehicle-pill';
import ViewCountPill from './view-count-pill';

interface VehiclePillsProps {
  // Brand new pill
  isNewVehicle: boolean;
  // View count pill
  showViewCount: boolean;
  viewCount: number;
}

export default function VehiclePills({
  // Brand new pill
  isNewVehicle,
  // View count pill
  showViewCount,
  viewCount,
}: VehiclePillsProps) {
  return (
    <div className="flex gap-[9px] px-[24px] md:px-0">
      {isNewVehicle ? <NewVehiclePill withoutShadow /> : null}
      {showViewCount ? <ViewCountPill viewCount={viewCount} /> : null}
    </div>
  );
}
